import React, { useEffect, useState } from "react";
import Index from "../../../../Index";
import PagesIndex from "../../../../PagesIndex";
import DataService, { imagePath } from "../../../../../config/DataService";
import {
  getAllFamilyWithMohollaNameAndAreaList,
  getCheckAuthenticationDocument,
  getCurrentYearSahayApplicationForView,
  getFamilyMemberById,
  getPreviousSahayApplicationListViewSahay,
  getSingleSahayApplication,
} from "../../../../../redux/features/AddService";
import { Api } from "../../../../../config/Api";
import { toast } from "react-toastify";
import PageLoading from "../../../../../components/common/pageLoading/PageLoading";

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#eaac35",
    color: "#ffffff",
    fontSize: "11px",
    fontFamily: "Poppins-Regular",
    padding: "5px 9px",
    lineHeight: "19px",
    borderRadius: "10px",
  },
}));

const ariaLabel = { "aria-label": "description" };
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const SahayApplicationView = () => {
  const [previousListData, setPreviousListData] = useState([]);

  const [singlaFamilyId, setSingleFamilyId] = useState();
  const [familyMembers, setFamilyMembers] = useState();
  const [editSingleApplicantData, setEditSingleApplicantData] = useState();
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [uploadSahayId, setUploadSahayId] = useState("");
  const [familyListWithArea, setFamilyListWithArea] = useState([]);
  const [showCurrentYearSahayApplication, setShowCurrentYearSahayApplication] =
    useState([]);

  const { state } = PagesIndex.useLocation();
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const [getViewData, setGetViewData] = useState(null);
  const [blobImageUrl, setBlobImgUrl] = useState(null);

  const [loader, setLoader] = useState(true);
  const initialValues = {};
  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const editPreviousData = state;

  const handleBack = () => {
    navigate(`/${rollData}/sahay-application`, {
      state: {
        rowId: state?.applicationId,
        tabType: "current",
        prevState: state?.lastStatus,
        prevSahayFilter: state?.SahayTypeFilter,
        prevSubSahayFilter: state?.subSahayTypeFilter,
      },
    });
  };

  const handleOpenUpload = (id) => {
    setUploadSahayId(id);
    setUploadOpen(true);
  };

  const handleCloseUploadModal = () => setUploadOpen(false);

  const getSingleSahayApplication = async () => {
    try {
      await DataService.get(
        `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.applicationId}`
      ).then((res) => {
        if (res.data.status === 200) {
          setLoader(false);
          setGetViewData(res?.data?.data);

          fetchSingleApplicant(res.data.data.application[0]);
        }
      });
    } catch (error) {
      // toast.error(error.response.data.message || error.message);
    }
  };

  const previousYearSahayList = () => {
    const data = {
      applicantId: state?.applicantId,
    };
    dispatch(getPreviousSahayApplicationListViewSahay(data)).then((res) => {
      if (res) {
        setLoader(false);
        setPreviousListData(res?.payload);
      }
      setLoader(false);
    });
  };

  //Single applicant
  const fetchSingleSelectedApplicant = (memberData) => {
    const member =
      memberData &&
      memberData?.filter(
        (member) => member?.id == editPreviousData?.applicantId
      );

    if (member?.[0]) {
      setEditSingleApplicantData({
        name:
          member?.[0]?.firstName +
          " " +
          member?.[0]?.middleName +
          " " +
          member?.[0]?.lastName,

        age: member?.[0]?.age ? member?.[0]?.age : 0,
        workingType: member?.[0]?.workingType,
        relation: member?.[0]?.relation,
        relation_id: member?.[0]?.relation_id,
      });
    }
  };

  //fetch single applicant
  const fetchSingleApplicant = (familydata) => {
    let familyId;
    if (editPreviousData?.editSahay) {
      familyId = editPreviousData?.editSahay?.familyId;
    } else {
      familyId = editPreviousData?.familyId;
    }

    let data;
    if (familydata?.vastipatrak == "0") {
      data = {
        familyId: familyId,
        VastiPatra: false,
      };
    } else {
      data = {
        familyId: familyId,
        VastiPatra: true,
      };
    }
    setSingleFamilyId(familyId);

    dispatch(getFamilyMemberById(data)).then((res) => {
      if (res?.payload) {
        setFamilyMembers(res?.payload);
        fetchSingleSelectedApplicant(res?.payload);
      }
    });
  };
  const fetchCurrentYearSahayApplications = (familydata) => {
    let familyId;
    if (editPreviousData?.editSahay) {
      familyId = editPreviousData?.editSahay?.familyId;
    } else {
      familyId = editPreviousData?.familyId;
    }
    const data = {
      familyId: familyId,
    };

    // setSingleFamilyId(familyId);

    dispatch(getCurrentYearSahayApplicationForView(data)).then((res) => {
      if (res?.payload) {
        setShowCurrentYearSahayApplication(res?.payload); //setShowCurrentYearSahayApplication
      }
    });
  };

  const handleUploadSubmit = async (values) => {
    // handleSahayApplicationStatus(approvedAmountIdData, "Approved");
    handleCloseUploadModal();
    const data = new FormData();

    values?.loanDoc?.forEach((row, index) =>
      data?.append(`loanDoc[${index}]`, row)
    );

    data?.append("id", uploadSahayId);

    try {
      const response = await DataService.post(
        `${Api.UPDATE_UPLOAD_LOAN_DOCUMENT}`,
        data
      );

      if (response?.data?.status === 200) {
        getSingleSahayApplication();
      }
    } catch (error) {}
  };

  useEffect(() => {
    getSingleSahayApplication();
    previousYearSahayList();
    fetchCurrentYearSahayApplications();
  }, []);

  const getFamilyListWithArea = () => {
    const data = {
      mobile: getViewData?.application[0]?.patanMemberMobile,
    };
    dispatch(getAllFamilyWithMohollaNameAndAreaList(data)).then((res) => {
      if (res?.payload) {
        setFamilyListWithArea(res?.payload?.data);
      } else {
        setFamilyListWithArea([]);
      }
    });
  };

  useEffect(() => {
    if (getViewData?.application[0]?.patanMemberMobile?.length >= 10) {
      getFamilyListWithArea();
    }
  }, [getViewData?.application[0]?.patanMemberMobile]);

  const renderDocument = (url, filename) => {
    let extension = "";

    if (filename) {
      extension = filename.split(".").pop().toLowerCase();
    } else if (url && url.startsWith("blob:")) {
      extension = ""; // Blob URL cannot detect type without filename
    } else if (url) {
      extension = url.split(".").pop().toLowerCase();
    }
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
      return <img src={url} alt="Document" className="fullscreen-image" />;
    } else if (extension === "pdf") {
      return (
        <iframe
          src={url}
          title="PDF Document"
          className="fullscreen-pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url
          )}`}
          title="Word Document"
          className="fullscreen-doc"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
    }
  };


   const openSecureImageWithAuth = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
      }

      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        const ComponentData = "adminviewsahay";
        navigate(`/${rollData}/doc-image-view`, {
          state: {
            blobUrl,
            docImageData,
            state,
            ComponentData,
          },
        });
      } else {
        toast.error("Signed URL not received.");
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  const openSecureImageWithAuthWithoutNavigate = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        setBlobImgUrl(blobUrl);
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };
  console.log("getViewData==getViewData", getViewData?.application[0]?.image);
  useEffect(() => {
    openSecureImageWithAuthWithoutNavigate(getViewData?.application[0]?.image);
  }, [getViewData?.application[0]?.image]);

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box>
                <Index.Box className="title-header-flex-button">
                  <Index.Box className="common-button blue-button flex-start save-btn res-set-search">
                    <Index.Button
                      variant="contained"
                      onClick={() => handleBack()}
                    >
                      Back
                    </Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <PagesIndex.Formik
                initialValues={initialValues}
                enableReinitialize
              >
                {({ values }) => (
                  <form>
                    <Index.Box className="">
                      <Index.Grid container spacing={3}>
                        {getViewData?.application[0]?.image && (
                          <Index.Grid item xs={12} sm={12} md={12}>
                            <Index.Box className="main-card-box">
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      View Sahay Application
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label "
                              >
                                Image (છબી)
                              </Index.Typography>
                              <Index.Box
                              style={{height:"50px", cursor:"pointer" }}
                                className="mb-5 mt-5"
                                onClick={() =>
                                  openSecureImageWithAuth(
                                    getViewData?.application[0]?.image
                                  )
                                }
                              >
                                {/* {renderDocument(
                                  state.blobUrl,
                                  state.docImageData
                                )} */}
                                {renderDocument(
                                  blobImageUrl,
                                  getViewData?.application[0]?.image
                                )}
                                {/* {getViewData?.application[0]?.image && (
                                  <img
                                    style={{ width: "120px", height: "120" }}
                                    src={`${imagePath}${getViewData?.application[0]?.image}`}
                                    className="  mb-5 mt-5"
                                  />
                                )} */}
                              </Index.Box>
                            </Index.Box>
                          </Index.Grid>
                        )}

                        {getViewData?.document
                          ?.map((data) => ({
                            documentType: data.documentType,
                            documents: data.documents?.filter(
                              (doc) => doc.document !== "null"
                            ),
                          }))
                          ?.filter((item) => item.documents?.length > 0)
                          ?.length > 0 ? (
                          <Index.Grid item xs={12} sm={12} md={12}>
                            <Index.Box className="main-card-box">
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Documents (દસ્તાવેજો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Grid item xs={12}>
                                <Index.Box className="select-view-document-name">
                                  <Index.Box className="select-view-document-name mt-select-doc">
                                    {/* <Index.Box className="select-view-document-name mt-select-doc">
                                  {getViewData?.document
                                    ?.map((data) =>
                                      data?.documents?.filter(
                                        (ele) => ele?.document !== "null"
                                      )
                                    )
                                    .map((item, fileIndex) => {
                                      return (
                                        <>
                                
                                          {item?.documentType  &&
                                            item?.documents?.length > 0 && (
                                              <Index.Box className="roles-data-box add-check-flex-doc">
                                                <Index.Box className="add-role-flex">
                                                  <Index.Box className="role-data-title">
                                                    {item.documentType}
                                                  </Index.Box>
                                                </Index.Box>
                                              </Index.Box>
                                            )}
                                          {item?.documents
                                            ?.filter(
                                              (ele) => ele?.document !== "null"
                                            )
                                            .map((document, documentIndex) => (
                                              <Index.Box
                                              className="select-view-document-name mt-select-doc"
                                              key={documentIndex}
                                              >
                                           
                                                <Index.Box className="document-name">
                                                  <Index.Typography
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      window.open(
                                                        document instanceof Blob
                                                          ? URL.createObjectURL(
                                                              document
                                                            )
                                                          : `${imagePath}${document?.filename}`
                                                      );
                                                    }}
                                                  >
                                                    {document instanceof Blob
                                                      ? document.name
                                                      : document?.document}
                                                  </Index.Typography>
                                                  <Index.IconButton
                                                    onClick={() => {
                                               
                                                      // Implement your logic to remove the document
                                                    }}
                                                  >
                                                    <Index.ClearIcon className="muiico-cancel" />
                                                  </Index.IconButton>
                                                </Index.Box>
                                              </Index.Box>
                                            ))}
                                        </>
                                      );
                                    })}
                                </Index.Box> */}

                                    {getViewData?.document
                                      ?.map((data) => ({
                                        documentType: data.documentType,
                                        documents: data.documents?.filter(
                                          (doc) =>
                                            doc.document !== "null" &&
                                            doc.document !== "demo.png"
                                        ),
                                      }))
                                      ?.filter(
                                        (item) => item.documents?.length > 0
                                      )
                                      ?.map((item, fileIndex) => (
                                        <>
                                          <div key={fileIndex}>
                                            <Index.Box className="roles-data-box add-check-flex-doc">
                                              <Index.Box className="add-role-flex">
                                                <Index.Box className="role-data-title">
                                                  {item.documentType}
                                                </Index.Box>
                                              </Index.Box>
                                            </Index.Box>

                                            {/* Iterate over filtered documents and display them */}
                                            <div>
                                              {item.documents.map(
                                                (document, documentIndex) => (
                                                  <Index.Box
                                                    className="select-view-document-name mt-select-doc"
                                                    key={documentIndex}
                                                  >
                                                    <Index.Box className="document-name">
                                                      <Index.Typography
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openSecureImageWithAuth(
                                                            document?.filename
                                                          )
                                                        }
                                                      >
                                                        {document instanceof
                                                        Blob
                                                          ? document.name
                                                          : document?.document}
                                                      </Index.Typography>
                                                    </Index.Box>
                                                  </Index.Box>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          ""
                        )}

                        {/* Loan Document Start  */}
                        {getViewData?.application?.[0]?.loanAgreementDoc &&
                          getViewData?.application?.[0]?.loanAgreementDoc
                            ?.length > 0 && (
                            <Index.Grid item xs={12} sm={12} md={12}>
                              {/* <Index.Box className="title-header"> */}
                              <Index.Box className="title-main ">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Loan Documents (લોન દસ્તાવેજો)
                                </Index.Typography>
                              </Index.Box>
                              {/* </Index.Box> */}

                              <Index.Grid item xs={8}>
                                <Index.Box className="select-view-document-name">
                                  <Index.Box className="select-view-document-name mt-select-doc">
                                    {getViewData?.application?.[0]
                                      ?.loanAgreementDoc &&
                                      // JSON.parse(
                                      getViewData?.application?.[0]?.loanAgreementDoc
                                        // )
                                        ?.map((item, fileIndex) => (
                                          <>
                                            {/* Iterate over filtered documents and display them */}

                                            <Index.Box className="select-view-document-name mt-select-doc">
                                              <Index.Box className="document-name">
                                                <Index.Typography
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    window.open(
                                                      item instanceof Blob
                                                        ? URL.createObjectURL(
                                                            item
                                                          )
                                                        : `${imagePath}${item?.Documents}`
                                                    );
                                                  }}
                                                >
                                                  {item instanceof Blob
                                                    ? item.Filename
                                                    : item?.Documents}
                                                </Index.Typography>
                                              </Index.Box>
                                            </Index.Box>
                                          </>
                                        ))}
                                    <Index.IconButton
                                      onClick={() => {
                                        handleOpenUpload(
                                          getViewData?.application?.[0]?.sahayId
                                        );
                                      }}
                                    >
                                      <Index.Typography>Edit</Index.Typography>
                                      <Index.EditIcon className="muiico-edit" />
                                    </Index.IconButton>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          )}
                        {/* Loan document End */}
                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Basic Details (મૂળભૂત વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={2} lg={2}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Family ID (કુટુંબ ID)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="familyId"
                                    disabled
                                    value={state?.familyId}
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Aadhar Card No. (આધાર કાર્ડ નં.)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.AadharNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sahay Category (સહાય કેટેગરી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Category"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.SahayName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sub Sahay Category (સબ સહાય શ્રેણી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Category"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.subSahayName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Year Of Sahay (સહાયનું વર્ષ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.Year
                                        ? getViewData?.application[0]?.Year
                                        : getViewData?.application[0]
                                            ?.fromYear === null
                                        ? "---"
                                        : ` ${getViewData?.application[0]?.fromYear}-${getViewData?.application[0]?.toYear}`
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={5} lg={5}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Application Received Date (અરજી મળ્યાની તારીખ)
                                </Index.Typography>

                                <Index.Box className="input-design-div with-border date-input-box">
                                  <Index.LocalizationProvider
                                    dateAdapter={Index.AdapterDayjs}
                                    sx={{ position: "absolute" }}
                                  >
                                    <Index.DemoContainer
                                      components={["DatePicker"]}
                                    >
                                      <Index.DatePicker
                                        className="admin-input-design input-placeholder"
                                        disabled
                                        name="applicationReceiveDate"
                                        // onChange={(value) => {
                                        //   setFieldValue(
                                        //     "applicationReceiveDate",
                                        //     moment(value.$d).format(
                                        //       "YYYY-MM-DD"
                                        //     )
                                        //   );
                                        // }}
                                        value={dayjs(
                                          getViewData?.application[0]
                                            ?.applicationReceiveDate
                                        )}
                                        format="YYYY-MM-DD"
                                        sx={{
                                          overflowY: "hidden",
                                          position: "relative",
                                          bottom: "8px",
                                          width: "100%",
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                          },
                                        }}
                                      />
                                    </Index.DemoContainer>
                                  </Index.LocalizationProvider>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Filing Date (ફાઇલિંગ તારીખ)
                                </Index.Typography>

                                <Index.Box className="input-design-div with-border date-input-box">
                                  <Index.LocalizationProvider
                                    dateAdapter={Index.AdapterDayjs}
                                    sx={{ position: "absolute" }}
                                  >
                                    <Index.DemoContainer
                                      components={["DatePicker"]}
                                    >
                                      <Index.DatePicker
                                        disabled
                                        className="admin-input-design input-placeholder"
                                        name="formFillingDate"
                                        // onChange={(value) => {
                                        //   setFieldValue(
                                        //     "formFillingDate",
                                        //     moment(value.$d).format(
                                        //       "YYYY-MM-DD"
                                        //     )
                                        //   );
                                        // }}
                                        value={dayjs(
                                          getViewData?.application[0]
                                            ?.formFillingDate
                                        )}
                                        format="YYYY-MM-DD"
                                        sx={{
                                          overflowY: "hidden",
                                          position: "relative",
                                          bottom: "8px",
                                          width: "100%",
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                          },
                                        }}
                                      />
                                    </Index.DemoContainer>
                                  </Index.LocalizationProvider>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>

                        {getViewData?.application[0]?.disease !== "NULL" ||
                          (null && (
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Type Of Disease (રોગનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.disease
                                      ? getViewData?.application[0]?.disease
                                      : "---"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                          ))}

                        {getViewData?.application[0]?.isLoan == true ? (
                          <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                            <Index.Typography
                              variant="label"
                              component="label"
                              className="input-label"
                            >
                              PAN CARD No. (વિસ્તાર)
                            </Index.Typography>
                            <Index.Box className="input-design-div with-border">
                              <Index.TextField
                                hiddenLabel
                                id="filled-hidden-label-normal"
                                variant="filled"
                                className="admin-input-design input-placeholder"
                                autoComplete="off"
                                name="Addharcard No."
                                disabled
                                // value={getViewData?.application[0]?.workingType}
                                value={
                                  getViewData
                                    ? getViewData?.application?.[0]?.PANCardNo
                                    : editSingleApplicantData?.PANCardNo
                                }
                              />
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          <></>
                        )}

                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Family Members Details (કુટુંબના સભ્યોની
                                        વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  First Name (પ્રથમ નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.firstName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Middle Name (મધ્ય નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.middleName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Last Name (છેલ્લું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="User Name"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.lastName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Relation (સંબંધ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      editSingleApplicantData
                                        ? editSingleApplicantData?.relation
                                        : getViewData?.application[0]?.relation
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Age (ઉંમર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData
                                        ? getViewData?.application[0]?.age
                                        : editSingleApplicantData?.age
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Working Type (કામનો પ્રકાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.workingType
                                        : editSingleApplicantData?.workingType
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Beneficiary Name (લાભાર્થીનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.beneficiaryMemName
                                        : getViewData?.application?.[0]
                                            ?.beneficiaryMemName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Family Income (કૌટુંબિક આવક){" "}
                                  <span className="required">*</span>
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.monthlyIncome
                                        : getViewData?.application?.[0]
                                            ?.monthlyIncome
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Electric Bill amount (ઇલેક્ટ્રિક બિલની રકમ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.threeMonthBillAmount
                                        : getViewData?.application?.[0]
                                            ?.threeMonthBillAmount
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>

                        {/* <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                          <Index.Typography
                            variant="label"
                            component="label"
                            className="input-label"
                          >
                            Monthly Income
                          </Index.Typography>
                          <Index.Box className="input-design-div with-border">
                            <Index.TextField
                              hiddenLabel
                              id="filled-hidden-label-normal"
                              variant="filled"
                              className="admin-input-design input-placeholder"
                              autoComplete="off"
                              name="Addharcard No."
                              disabled
                              value={
                                getViewData?.application[0]?.monthlyIncome
                                  ? getViewData?.application[0]?.monthlyIncome
                                  : "---"
                              }
                            />
                          </Index.Box>
                        </Index.Grid> */}

                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Bank Details (બેંક વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Bank Name (બેંકનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.bankName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Branch (શાખા)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={getViewData?.application[0]?.branch}
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Account Holder Name (એકાઉન્ટ ધારકનું નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.HolderName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Account Number (એકાઉન્ટ નંબર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.AccountNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  IFSC code (IFSC કોડ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]?.IFSCCode
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>

                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Sahay Details (સહાય વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                              {getViewData?.application[0]?.claimedAmmount !==
                                0 && (
                                <>
                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      {/* Claimed Sahay Amount */}
                                      Total Requested Sahay Amount (કુલ વિનંતી
                                      કરેલ સહાય રકમ)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        autoComplete="off"
                                        name="Addharcard No."
                                        disabled
                                        value={
                                          getViewData?.application[0]
                                            ?.claimedAmmount
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>{" "}
                                </>
                              )}
                              {getViewData?.application[0]?.approveAmount &&
                              getViewData?.application[0]?.approveAmount !==
                                0 ? (
                                <>
                                  <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                    <Index.Typography
                                      variant="label"
                                      component="label"
                                      className="input-label"
                                    >
                                      {/* Claimed Sahay Amount */}
                                      Approve Amount* (રકમ મંજૂર)
                                    </Index.Typography>
                                    <Index.Box className="input-design-div with-border">
                                      <Index.TextField
                                        hiddenLabel
                                        id="filled-hidden-label-normal"
                                        variant="filled"
                                        className="admin-input-design input-placeholder"
                                        autoComplete="off"
                                        name="Addharcard No."
                                        disabled
                                        value={
                                          getViewData?.application[0]
                                            ?.approveAmount
                                        }
                                      />
                                    </Index.Box>
                                  </Index.Grid>{" "}
                                </>
                              ) : (
                                ""
                              )}
                              <Index.Grid item xs={12} sm={6} md={6}>
                                <Index.Box className="lable-input-grp">
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Remark (ટિપ્પણી)
                                  </Index.Typography>
                                  {/* <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="remark"
                                        value={values?.remark}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      /> */}
                                  <Index.TextareaAutosize
                                    style={{
                                      fontSize: "15px",
                                      color: "black",
                                      padding: "4px",
                                      minHeight: "50px",
                                      width: "100%",
                                    }}
                                    minRows={1}
                                    inputProps={ariaLabel}
                                    className="basic-input input-width"
                                    name="remark"
                                    value={getViewData?.application[0]?.remark}

                                    // onBlur={handleBlur}
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>

                        <Index.Grid item xs={12} sm={12} md={12}>
                          <Index.Box className="main-card-box">
                            <Index.Grid container spacing={2}>
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Reference / Guarantor (સંદર્ભ / બાંયધરી
                                        આપનાર)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>

                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Mobile Number (મોબાઈલ નંબર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      getViewData?.application[0]
                                        ?.patanMemberMobile
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  FID (કૌટુંબિક આઈડી)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.mem_family_id
                                        : ""
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={6} lg={6}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Reference / Guarantor (સંદર્ભ / બાંયધરી આપનાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile
                                      )
                                        ? `${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile
                                            )?.mem_fname
                                          } ${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile
                                            )?.mem_mname
                                          } ${
                                            familyListWithArea.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                getViewData?.application[0]
                                                  ?.patanMemberMobile
                                            )?.mem_lname
                                          }`
                                        : values?.patanReferenceName
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Mohalla Name (મહોલ્લો નામ)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.mohollo_name
                                        : values?.patanReferenceMohollo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                              <Index.Grid item xs={12} sm={6} md={3} lg={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Area (વિસ્તાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    value={
                                      familyListWithArea?.find(
                                        (row) =>
                                          row?.mem_mobile ==
                                          getViewData?.application[0]
                                            ?.patanMemberMobile
                                      )
                                        ? familyListWithArea?.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.family_area
                                        : values?.patanReferenceArea
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            </Index.Grid>
                          </Index.Box>
                        </Index.Grid>

                        <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Family Members Details (કુટુંબના સભ્યોની
                                  વિગતો)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow>
                                    <Index.TableCell>
                                      Name (નામ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Age (ઉંમર)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Relation (સંબંધ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Working Type (કામનો પ્રકાર)
                                    </Index.TableCell>
                                    {/* <Index.TableCell align="left">
                                      {" "}
                                      Monthly Income
                                    </Index.TableCell> */}
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {/* {getViewData?.relationRecords?.length ? (
                                    getViewData?.relationRecords */}
                                  {familyMembers?.length ? (
                                    familyMembers
                                      ?.filter((ele) => {
                                        return (
                                          ele?.id !=
                                          getViewData?.application?.[0]
                                            ?.applicantId
                                        );
                                      })
                                      ?.map((data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${data?.firstName} ${data?.middleName} ${data?.lastName}` ||
                                                "-"}
                                            </Index.TableCell>

                                            <Index.TableCell align="left">
                                              {data?.age || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.relation || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.workingType || "-"}
                                              {/* {data?.WorkingType} */}
                                            </Index.TableCell>
                                            {/* <Index.TableCell align="left">
                                              {data?.monthlyIncome}
                                            </Index.TableCell> */}
                                          </Index.TableRow>
                                        );
                                      })
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={6}
                                        align="center"
                                      >
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid>

                        <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Current Year Sahay (વર્તમાન વર્ષ સહાય)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow className="sahay-appli-tr">
                                    <Index.TableCell className="sahay-appli-tr">
                                      Family Id
                                    </Index.TableCell>
                                    <Index.TableCell className="user-sahay-td">
                                      User Name
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Type Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell className="sahay-appli-tr">
                                      Sub Type Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Requested Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Approved Amount
                                    </Index.TableCell>

                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Year Of Sahay
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Staff Status
                                    </Index.TableCell>
                                    <Index.TableCell
                                      className="sahay-appli-tr"
                                      align="left"
                                    >
                                      Committee Status
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {/* {getViewData?.relationRecords?.length ? (
                                    getViewData?.relationRecords */}
                                  {showCurrentYearSahayApplication?.length ? (
                                    showCurrentYearSahayApplication?.map(
                                      (data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${
                                                data?.familyId
                                                  ? data?.familyId
                                                  : data?.mem_family_id
                                              }` || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              {/* {data?.name} */}
                                              {`${data?.mem_fname} ${data?.mem_mname} ${data?.mem_lname}` ||
                                                "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.Sahay_category || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.SahayName || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.claimedAmmount
                                                ? data?.claimedAmmount
                                                : "0"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.approveAmount
                                                ? data?.approveAmount
                                                : "0"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {`${data?.fromSahayYear} - ${data?.toSahayYear}` ||
                                                "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.NewStatusColumn || "-"}
                                            </Index.TableCell>
                                            <Index.TableCell align="left">
                                              {data?.committeeStatus || "-"}
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      }
                                    )
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={6}
                                        align="center"
                                      >
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid>

                        {/* <Index.Grid item xs={12} md={12}>
                          <Index.Box className="title-header" mt={5}>
                            <Index.Box className="title-header-flex res-title-header-flex">
                              <Index.Box className="title-main">
                                <Index.Typography
                                  variant="p"
                                  component="p"
                                  className="page-title"
                                >
                                  Trust (ટ્રસ્ટ)
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="">
                            <Index.TableContainer
                              component={Index.Paper}
                              className="table-container"
                            >
                              <Index.Table
                                aria-label="simple table"
                                className="table-design-main barge-table "
                              >
                                <Index.TableHead>
                                  <Index.TableRow>
                                    <Index.TableCell align="left">
                                      Trust Name (ટ્રસ્ટનું નામ)
                                    </Index.TableCell>
                                    <Index.TableCell align="left">
                                      {" "}
                                      Account (એકાઉન્ટ)
                                    </Index.TableCell>
                                  </Index.TableRow>
                                </Index.TableHead>
                                <Index.TableBody>
                                  {getViewData?.trustRecords?.length ? (
                                    getViewData?.trustRecords?.map(
                                      (data, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell align="left">
                                              {data?.trustName}
                                            </Index.TableCell>

                                            <Index.TableCell align="left">
                                              {data?.ammount}
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      }
                                    )
                                  ) : (
                                    <Index.TableRow>
                                      <Index.TableCell
                                        component="td"
                                        variant="td"
                                        scope="row"
                                        className="no-data-in-list"
                                        colSpan={2}
                                        align="center"
                                      >
          
                                        No data available
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  )}
                                </Index.TableBody>
                              </Index.Table>
                            </Index.TableContainer>
                          </Index.Box>
                        </Index.Grid> */}

                        {rollData.toLowerCase() === "committee" ? (
                          <Index.Grid item xs={12} md={12}>
                            <Index.Box className="title-header" mt={5}>
                              <Index.Box className="title-header-flex res-title-header-flex">
                                <Index.Box className="title-main">
                                  <Index.Typography
                                    variant="p"
                                    component="p"
                                    className="page-title"
                                  >
                                    Previous Year Sahay (ગત વર્ષ સહાય)
                                  </Index.Typography>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box className="">
                              <Index.TableContainer
                                component={Index.Paper}
                                className="table-container"
                              >
                                <Index.Table
                                  aria-label="simple table"
                                  className="table-design-main barge-table "
                                >
                                  <Index.TableHead>
                                    <Index.TableRow>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Family Id (કૌટુંબિક આઈડી)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        User Name (વપરાશકર્તા નામ)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Type Of Sahay (સહાયનો પ્રકાર)
                                      </Index.TableCell>
                                      <Index.TableCell className="sahay-appli-tr">
                                        Sub Type Of Sahay (સહાયનો પેટા પ્રકાર)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Requested Sahay (સહાયને વિનંતી કરી)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Approved Amount (મંજૂર રકમ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Year Of Sahay (સહાયનું વર્ષ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Start Date (પ્રારંભ તારીખ)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        No. Of Month (મહિનાની સંખ્યા)
                                      </Index.TableCell>
                                      <Index.TableCell
                                        className="sahay-appli-tr"
                                        align="left"
                                      >
                                        Repay Details (ચુકવણી વિગતો)
                                      </Index.TableCell>
                                    </Index.TableRow>
                                  </Index.TableHead>
                                  <Index.TableBody>
                                    {previousListData?.length ? (
                                      previousListData?.map((row, index) => {
                                        return (
                                          <Index.TableRow key={index}>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.familyId}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {`${row?.firstName} ${row?.middleName} ${row?.lastName}`}
                                            </Index.TableCell>

                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.SahayName}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.Sahay_category}
                                            </Index.TableCell>

                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.sahayAmmount}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.approveAmount}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.toYear
                                                ? `${row?.fromYear}- ${row?.toYear}`
                                                : "---"}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.startDate
                                                ? new Date(
                                                    row?.startDate
                                                  )?.toLocaleDateString("en-GB")
                                                : "-"}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              align="left"
                                              className="sahay-appli-td"
                                            >
                                              {row?.numberOfMonths !== null
                                                ? row?.numberOfMonths
                                                : "----"}
                                            </Index.TableCell>

                                            <LightTooltip
                                              title={row?.repayDetails}
                                            >
                                              <Index.TableCell
                                                align="left"
                                                className="sahay-appli-td"
                                              >
                                                {row.repayDetails !== null
                                                  ? row.repayDetails
                                                      // ?.split(" ")
                                                      ?.slice(0, 15) + "......"
                                                  : // ?.join(" ")+ "..."
                                                    "----"}
                                              </Index.TableCell>
                                            </LightTooltip>
                                          </Index.TableRow>
                                        );
                                      })
                                    ) : (
                                      <Index.TableRow>
                                        <Index.TableCell
                                          component="td"
                                          variant="td"
                                          scope="row"
                                          className="no-data-in-list"
                                          colSpan={6}
                                          align="center"
                                        >
                                          No data available
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    )}
                                  </Index.TableBody>
                                </Index.Table>
                              </Index.TableContainer>
                            </Index.Box>
                          </Index.Grid>
                        ) : (
                          ""
                        )}
                        {/* table */}
                      </Index.Grid>

                      <Index.Box className="line" mt={3} mb={3}></Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Box>

          <Index.Modal
            open={uploadOpen}
            onClose={handleCloseUploadModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="modal-delete modal"
          >
            <Index.Box
              sx={style}
              className="delete-modal-inner-main modal-inner approve-amount-model"
            >
              <PagesIndex.Formik
                enableReinitialize
                onSubmit={handleUploadSubmit}
                // validationSchema={uploadLoanDocSchema}
                initialValues={{
                  loanDoc: [],
                }}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  touched,
                  setFieldValue,
                  handleBlur,
                  errors,
                  isValid,
                  isSubmitting,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Index.Box
                    // className={`${
                    //   subSahayType == "" ? "remark-textarea-details" : ""
                    // }`}
                    >
                      <Index.Box className="set-text-area ">
                        <Index.Box
                          sx={{ flexGrow: 1 }}
                          className="al-form-groups"
                        >
                          <Index.Grid container spacing={2}>
                            <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                              <Index.Box
                                sx={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <Index.IconButton
                                  onClick={handleCloseUploadModal}
                                >
                                  <Index.CloseIcon />
                                </Index.IconButton>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={12} md={12} lg={12}>
                              <Index.Box className="lable-input-grp">
                                <Index.Typography
                                  component="p"
                                  className="in-label"
                                >
                                  Upload Document
                                </Index.Typography>
                                <Index.Box className="select-position">
                                  <input
                                    type="file"
                                    name="loanDoc"
                                    className="ori-input"
                                    onChange={(event) => {
                                      const files = Array.from(
                                        event.target.files
                                      );
                                      setFieldValue("loanDoc", files);
                                    }}
                                    multiple
                                  />

                                  <Index.Box className="select-file">
                                    Upload Your Document
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              {errors?.loanDoc && touched?.loanDoc && (
                                <p
                                  className="error-text"
                                  style={{ marginTop: "10px" }}
                                >
                                  {errors?.loanDoc}
                                </p>
                              )}
                            </Index.Grid>

                            <Index.Grid item xs={8}>
                              <Index.Box className="select-view-document-name remove-margin-upload">
                                {values.loanDoc?.length > 0 &&
                                  values?.loanDoc?.map((item, fileIndex) => {
                                    return (
                                      <Index.Box className="select-view-document-name mt-select-doc">
                                        <Index.Box className="document-name">
                                          <Index.Typography
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                item instanceof Blob
                                                  ? URL.createObjectURL(item)
                                                  : // : `${imagePath}${values.documents[index].filePath}`
                                                    `${imagePath}${item?.filename}`
                                              );
                                            }}
                                          >
                                            {item instanceof Blob
                                              ? item.name
                                              : item?.document}
                                          </Index.Typography>
                                          <Index.IconButton
                                            onClick={() => {
                                              const updatedFiles =
                                                values.loanDoc?.filter(
                                                  (ele, i) => i !== fileIndex
                                                );
                                              setFieldValue(
                                                `loanDoc`,
                                                updatedFiles
                                              );
                                            }}
                                          >
                                            <Index.ClearIcon className="muiico-cancel" />
                                          </Index.IconButton>
                                        </Index.Box>
                                      </Index.Box>
                                    );
                                  })}
                              </Index.Box>
                            </Index.Grid>
                          </Index.Grid>
                        </Index.Box>
                      </Index.Box>
                      <Index.Box className="btn-submit-area">
                        <Index.Box className="common-button blue-button change-password-btn update_priofile_btn">
                          <Index.Button
                            variant="contained"
                            disableRipple
                            type="submit"
                          >
                            Submit
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </form>
                )}
              </PagesIndex.Formik>
            </Index.Box>
          </Index.Modal>
        </>
      )}
    </>
  );
};

export default SahayApplicationView;
